import { FC } from 'react';

import { IconContainer } from '../IconContainer';
import { IconProps } from '../types';

export const Car20: FC<IconProps> = ({
  size = 20,
  color = 'currentColor',
  className,
  style,
  svgClassName,
  svgStyle,
  ariaLabel,
  onClick,
}) => {
  return (
    <IconContainer
      size={size}
      className={className}
      style={style}
      ariaLabel={ariaLabel}
      onClick={onClick}
    >
      <svg
        width={size}
        height={size}
        viewBox="0 0 20 20"
        fill="none"
        xmlns="http://www.w3.org/2000/svg"
        className={svgClassName}
        style={svgStyle}
      >
        <path d="M14.1667 14.1667C13.7067 14.1667 13.3333 13.7933 13.3333 13.3333C13.3333 12.8733 13.7067 12.5 14.1667 12.5C14.6267 12.5 15 12.8733 15 13.3333C15 13.7933 14.6267 14.1667 14.1667 14.1667ZM5.83333 14.1667C5.37333 14.1667 5 13.7933 5 13.3333C5 12.8733 5.37333 12.5 5.83333 12.5C6.29333 12.5 6.66667 12.8733 6.66667 13.3333C6.66667 13.7933 6.29333 14.1667 5.83333 14.1667ZM6.32333 7.12417C6.9925 6.92917 8.22167 6.66667 10 6.66667C11.7875 6.66667 13.02 6.93167 13.6817 7.125L14.9575 10.8333H5.07417L6.32333 7.12417ZM16.1467 9.16667L15 5.83333C15 5.83333 13.3333 5 10 5C6.66667 5 5 5.83333 5 5.83333L3.8775 9.16667H2.5V10.8333L3.33333 11.6667V15V15.8333V16.6667H5C5.46 16.6667 5.83333 16.2933 5.83333 15.8333H14.1667C14.1667 16.2933 14.54 16.6667 15 16.6667H16.6667V15.8333V15V11.6667H16.6675L17.5008 10.8333V9.16667H16.1467Z" fill={color} />
      </svg>
    </IconContainer>
  );
};
